import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export function CoverageLeaflet({ points = [], states = [], height = 480, showNames = true }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false, attributionControl: false }).setView([30.5, -83.5], 6);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 18, subdomains: "abc" }).addTo(map);
    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    map.eachLayer((l) => { if (l instanceof L.Circle || l instanceof L.CircleMarker) map.removeLayer(l); });
    const bounds = [];
    points.forEach((p) => {
      if (p.lat == null || p.lng == null) return;
      const color = p.color || "#FF5722";
      L.circle([p.lat, p.lng], { radius: (p.radius_mi || 60) * 1609, color, weight: 1, fillColor: color, fillOpacity: 0.12 }).addTo(map);
      const m = L.circleMarker([p.lat, p.lng], { radius: 5, color, weight: 2, fillColor: color, fillOpacity: 0.9 }).addTo(map);
      if (showNames && (p.name || p.zip)) m.bindPopup(`<b>${p.name || ""}</b><br/>${p.zip || ""} · ${p.state || ""}`);
      bounds.push([p.lat, p.lng]);
    });
    if (bounds.length) { try { map.fitBounds(bounds, { padding: [40, 40], maxZoom: 8 }); } catch (e) { /* noop */ } }
    setTimeout(() => map.invalidateSize(), 150);
  }, [points, showNames]);

  return (
    <div>
      <div ref={ref} data-testid="coverage-leaflet" style={{ height, width: "100%", background: "#111" }} />
      {states.length > 0 && (
        <div className="flex flex-wrap gap-3 p-3 border-t border-zinc-800 bg-zinc-950">
          {states.map((s) => (
            <span key={s.code} className="inline-flex items-center gap-1.5 font-mono text-[11px] text-zinc-300">
              <span className="w-3 h-3 rounded-full inline-block" style={{ background: s.color }} /> {s.name} ({s.code})
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
